module.exports = __webpack_public_path__ + "55f8b45645784a18eab30a60ff1213a2.png";